// ─────────────────────────────────────────────────────────────────────────────
// Schema-driven Field Types
// ─────────────────────────────────────────────────────────────────────────────
/**
 * Value convention of the "tristate" inputType: a fixed three-option
 * radio (yes/no/unknown) whose labels the form component localizes
 * itself — the field needs no `options`. Unanswered fields are
 * normalized to "unknown" on extract; readers treat missing values and
 * "unknown" identically.
 */
export const TRISTATE_YES = "yes";
export const TRISTATE_NO = "no";
export const TRISTATE_UNKNOWN = "unknown";
// ─────────────────────────────────────────────────────────────────────────────
// Type Guards
// ─────────────────────────────────────────────────────────────────────────────
export function isRow(entry) {
    return "kind" in entry && entry.kind === "row";
}
export function isFieldset(entry) {
    return "kind" in entry && entry.kind === "fieldset";
}
// ─────────────────────────────────────────────────────────────────────────────
// Schema Helpers
// ─────────────────────────────────────────────────────────────────────────────
/**
 * Recursively collects all FieldSchema from a schema definition.
 */
export function resolveFields(schema) {
    return schema.flatMap((e) => {
        if (isRow(e))
            return e.fields;
        if (isFieldset(e))
            return e.rows.flat();
        return [e];
    });
}
// ─────────────────────────────────────────────────────────────────────────────
// Schema Helper Functions
// ─────────────────────────────────────────────────────────────────────────────
/**
 * Get a field value from schema data
 */
export function getSchemaFieldValue(data, fieldId) {
    return data?.[fieldId]?.value;
}
/**
 * Create a field value for storage
 */
export function createSchemaFieldValue(value, type) {
    return { value, type };
}
/**
 * Initialize empty schema data from a schema definition
 */
export function initSchemaData(schema) {
    const data = {};
    for (const field of resolveFields(schema)) {
        const defaultValue = field.type === "boolean" ? false : "";
        data[field.fieldId] = { value: defaultValue, type: field.type };
    }
    return data;
}
/**
 * Format a field value for display
 */
export function formatSchemaFieldValue(fieldValue, options) {
    const { boolTrue = "Ja", boolFalse = "Nein", empty = "–" } = options || {};
    if (!fieldValue)
        return empty;
    if (fieldValue.type === "boolean") {
        return fieldValue.value === true ? boolTrue : boolFalse;
    }
    return fieldValue.value ? String(fieldValue.value) : empty;
}
//# sourceMappingURL=pd-schema-model.js.map